import api from './api';

export async function baixarArquivoProtegido(nome) {
  const response = await api.get(
    `/api/arquivos/${encodeURIComponent(nome)}/download`,
    { responseType: 'blob' }
  );

  const objectUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
}
